export const SEARCH_CONTAINER = 'search_container';
export const USER_ACTION_CONTAINER = 'user_action_container';
